
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FileItemProps } from ".";
import { loading, endLoading, remove } from "store/file";

interface ApiFileRemoveInputProps {
    ids: number[]
}

type ApiFileRemoveOutputProps = OutputBaseProps<{ item: FileItemProps; }>;

export const apiFileRemove = async (data: ApiFileRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiFileRemoveOutputProps>("/api/file/remove", { data }))
        .data;
    if (res.code === 0) {
        store.dispatch(remove(data));
    }
    store.dispatch(endLoading());
    return res;
};